const DECLARATION_PROBE_BYTES = 256;

function bomEncoding(bytes: Uint8Array): string | null {
    if (bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf) return "utf-8";
    if (bytes[0] === 0xff && bytes[1] === 0xfe) return "utf-16le";
    if (bytes[0] === 0xfe && bytes[1] === 0xff) return "utf-16be";
    if (bytes[0] === 0x3c && bytes[1] === 0x00) return "utf-16le";
    if (bytes[0] === 0x00 && bytes[1] === 0x3c) return "utf-16be";

    return null;
}

function declaredEncoding(bytes: Uint8Array): string | null {
    const probe = String.fromCharCode(...bytes.subarray(0, DECLARATION_PROBE_BYTES));
    const match = /^<\?xml[^>]*\bencoding\s*=\s*["']([A-Za-z0-9._-]+)["']/.exec(probe);

    return match ? match[1] : null;
}

function decoderFor(label: string | null): TextDecoder {
    try {
        return new TextDecoder(label ?? "utf-8");
    } catch {
        return new TextDecoder("utf-8");
    }
}

export default function decodeXml(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    const encoding = bomEncoding(bytes) ?? declaredEncoding(bytes);

    return decoderFor(encoding).decode(bytes);
}
